import React from 'react';
import ABBLogo from '../../assets/images/ABBLogo.svg';
//import spinner from '../../assets/images/spinner.gif';
// import icons from '../../data/icons';
import './OfflineError.css';

const OfflineError = () =>
  (
    <section className={'offlineError'}>
      <img className={'offlineError__abb'} src={ABBLogo} alt={'abb logo'} />
      <section className={'offlineError__mainArea'}>
        <div style={{height:80}}></div>
        <h1 className={'offlineError__title'}>ABB Services &amp; Consulting</h1>
        <h3 className={'offlineError__text'}>This app is currently in Offline mode.</h3>
      </section>
    </section>
  );

export default OfflineError;



// WEBPACK FOOTER //
// ./src/components/OfflineError/OfflineError.js